import {
    CollectionServiceType,
} from 'app/enums/label.enums'
import {
    TypeIcon,
} from 'app/shared-components/NotificationIcon/notificationIcon.types'
import {
    WithId,
} from 'app/types/common.types'
import {
    FieldInCard,
    NestedField,
} from 'app/types/form.types'

import TooltipContentCollectionService
    from '../AccountLaneTooltipContent/TooltipContentCollectionService'
import {
    AccountLaneFormFields,
} from '../AccountLaneForm.fields'

export default ({
    getAllowedValues,
    isCollection,
    collectionDropoffPointCountry,
    disabled,
    isStatusPriced,
}: {
    getAllowedValues: (val: Record<string, string>) => Record<string, string>,
    isCollection: boolean,
    collectionDropoffPointCountry?: WithId<number>,
    disabled?: boolean,
    isStatusPriced?: boolean,
}): FieldInCard<keyof AccountLaneFormFields>[] => {
    return [
        {
            id: 'column1',
            fields: [{
                name: 'collectionServiceType',
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(CollectionServiceType),
                labelKey: 'AccountLane.collectionServiceType',
                notificationIconProps: {
                    content: TooltipContentCollectionService,
                    type: TypeIcon.INFO,
                },
                required: true,
                useDropdown: true,
                disabled: disabled || isStatusPriced,
            }],
        },
        {
            id: 'column2',
            fields: [
                ...(isCollection ? [
                    {
                        name: 'collectionDropoffPointCountry',
                        componentName: 'CountryDataSelector',
                        labelKey: 'AccountLane.collectionDropoffPointCountry',
                        required: true,
                        disabled: disabled || isStatusPriced,
                    },
                    {
                        name: 'collectionDropoffPointZipCode',
                        componentName: 'ZipCodeInput',
                        labelKey: 'AccountLane.collectionDropoffPointZipCode',
                        required: true,
                        country: collectionDropoffPointCountry,
                        disabled: disabled || isStatusPriced,
                    },
                    {
                        name: 'collectionDropoffPointAddress',
                        componentName: 'InputSingleline',
                        labelKey: 'AccountLane.collectionDropoffPointAddress',
                        disabled,
                    },
                ] as NestedField<keyof AccountLaneFormFields>[] : []),
                {
                    name: 'collectionDropoffPointContacts',
                    componentName: 'MultipleContactObjectSelector',
                    labelKey: 'AccountLane.collectionDropoffPointContacts',
                    disabled,
                },
            ],
        },
    ]
}
